/* Woodyworkz teknik çizim: ön, yan ve üst görünüş + antet. Ölçüler cm. */
(function () {
  var NS = 'http://www.w3.org/2000/svg', INK = '#231c17', MUTE = '#7a7068';
  function el(t, a, txt) { var e = document.createElementNS(NS, t); for (var k in a) e.setAttribute(k, a[k]); if (txt != null) e.textContent = txt; return e; }
  function nums(t) { var m = (t || '').match(/\d+(?:[.,]\d+)?/g); return m ? m.map(function (x) { return parseFloat(x.replace(',', '.')); }) : []; }
  function fmt(n) { return (Math.round(n * 10) / 10).toString().replace('.', ','); }

  function draw(svg, o) {
    while (svg.firstChild) svg.removeChild(svg.firstChild);
    var L = o.L, D = o.D, H = o.H, t = o.t, table = o.table;
    var tall = (svg.parentNode.clientWidth || 1000) < 620;
    var W = tall ? 600 : 1000, Hh = 620;
    var g = el('g', { fill: 'none', stroke: INK, 'stroke-linecap': 'square' }); svg.appendChild(g);
    var T = el('g', { fill: INK, 'font-family': 'Jost, Futura, system-ui, sans-serif', 'font-size': tall ? 19 : 15, 'letter-spacing': '.4' }); svg.appendChild(T);
    function line(x1, y1, x2, y2, w, dash, op) { var a = { x1: x1, y1: y1, x2: x2, y2: y2, 'stroke-width': w || 1 }; if (dash) a['stroke-dasharray'] = dash; if (op) a['stroke-opacity'] = op; g.appendChild(el('line', a)); }
    function rect(x, y, w, h, sw, dash, fill) { var a = { x: x, y: y, width: w, height: h, 'stroke-width': sw || 1.4 }; if (dash) a['stroke-dasharray'] = dash; if (fill) a.fill = fill; g.appendChild(el('rect', a)); }
    function text(x, y, s, a) { var at = { x: x, y: y }; for (var k in a) at[k] = a[k]; T.appendChild(el('text', at, s)); }
    function tick(x, y) { line(x - 4, y + 4, x + 4, y - 4, 1.1); }
    /* yatay ölçü çizgisi: x1..x2, nesne kenarı oy, ölçü çizgisi dy */
    function dimH(x1, x2, oy, dy, label) {
      var dir = dy < oy ? -1 : 1;
      [x1, x2].forEach(function (x) { line(x, oy + dir * 5, x, dy + dir * 6, .6); tick(x, dy); });
      line(x1 - 8, dy, x2 + 8, dy, .6);
      text((x1 + x2) / 2, dy - 7, label, { 'text-anchor': 'middle' });
    }
    function dimV(y1, y2, ox, dx, label) {
      var dir = dx < ox ? -1 : 1;
      [y1, y2].forEach(function (y) { line(ox + dir * 5, y, dx + dir * 6, y, .6); tick(dx, y); });
      line(dx, y1 - 8, dx, y2 + 8, .6);
      var tx = dx - 8, ty = (y1 + y2) / 2;
      T.appendChild(el('text', { x: tx, y: ty, 'text-anchor': 'middle', transform: 'rotate(-90 ' + tx + ' ' + ty + ')' }, label));
    }
    function label(x, y, s) { text(x, y, s, { 'font-size': tall ? 15 : 12, 'letter-spacing': '2.2', fill: MUTE }); line(x, y + 7, x + 26, y + 7, .8); }

    var hasH = H > 0;
    var k = tall ? Math.min(430 / L, hasH ? 170 / H : 1e9, 170 / D, 380 / D) : Math.min(520 / L, hasH ? 210 / H : 1e9, 200 / D, 210 / D);
    var fx = tall ? 90 : 120, fy = 70;                       /* ön görünüş sol üst */
    var l = L * k, h = H * k, d = D * k, tt = Math.max(t * k, 2.5);
    var groundY = fy + h;
    /* parça ölçüleri (cm) */
    var legIn = table ? Math.min(Math.max(L * .09, 12), 30) : 0;
    var legW = table ? 10 : Math.min(Math.max(L * .08, 8), 18);
    var postIn = table ? 8 : 0, postW = table ? 10 : D;
    var strY1 = 12, strY2 = 20;

    if (hasH) {
      /* ÖN GÖRÜNÜŞ */
      rect(fx, fy, l, tt);
      [fx + legIn * k, fx + l - (legIn + legW) * k].forEach(function (x) { rect(x, fy + tt, legW * k, h - tt); });
      if (table && H > 40) rect(fx + (legIn + legW) * k, groundY - strY2 * k, l - 2 * (legIn + legW) * k, (strY2 - strY1) * k, 1);
      line(fx - 30, groundY, fx + l + 30, groundY, .6, null, .5);
      dimH(fx, fx + l, fy, fy - 30, fmt(L));
      dimV(fy, groundY, fx, fx - 34, fmt(H));
      /* tabla kalınlığı göstergesi */
      var cx = fx + l + 18;
      line(fx + l + 5, fy, cx + 6, fy, .6); line(fx + l + 5, fy + tt, cx + 6, fy + tt, .6);
      tick(cx, fy); tick(cx, fy + tt);
      text(cx + 10, fy + tt / 2 + 4, fmt(t), { 'font-size': 12 });
      label(fx, groundY + 34, 'ÖN GÖRÜNÜŞ');

      /* YAN GÖRÜNÜŞ */
      var sx = tall ? fx : fx + l + 120, sy0 = fy;
      if (tall) { fy = groundY + 130; groundY = fy + h; }
      rect(sx, fy, d, tt);
      if (table) {
        [sx + postIn * k, sx + d - (postIn + postW) * k].forEach(function (x) { rect(x, fy + tt, postW * k, h - tt); });
        rect(sx + (postIn + postW) * k, fy + tt, d - 2 * (postIn + postW) * k, 8 * k, 1);
        if (H > 40) rect(sx + (postIn + postW) * k, groundY - strY2 * k, d - 2 * (postIn + postW) * k, (strY2 - strY1) * k, 1);
      } else {
        rect(sx, fy + tt, d, h - tt, 1.4);
      }
      line(sx - 20, groundY, sx + d + 20, groundY, .6, null, .5);
      dimH(sx, sx + d, fy, fy - 30, fmt(D));
      label(sx, groundY + 34, 'YAN GÖRÜNÜŞ');
      if (tall) fy = sy0;
    }

    /* ÜST GÖRÜNÜŞ */
    var py = hasH ? groundY + 100 : fy + 10;
    rect(fx, py, l, d);
    var boards = D >= 100 ? 5 : D >= 70 ? 4 : D >= 40 ? 3 : 2;
    for (var i = 1; i < boards; i++) line(fx, py + d * i / boards, fx + l, py + d * i / boards, .5, null, .35);
    [fx + legIn * k, fx + l - (legIn + legW) * k].forEach(function (x) { rect(x, py + postIn * k, legW * k, d - 2 * postIn * k, .8, '6 4'); });
    if (table) line(fx + (legIn + legW) * k, py + d / 2, fx + l - (legIn + legW) * k, py + d / 2, .8, '6 4');
    line(fx - 14, py + d / 2, fx + l + 14, py + d / 2, .5, '16 4 2 4', .55);
    line(fx + l / 2, py - 14, fx + l / 2, py + d + 14, .5, '16 4 2 4', .55);
    dimV(py, py + d, fx + l, fx + l + 34, fmt(D));
    dimH(fx, fx + l, py + d, py + d + 30, fmt(L));
    label(fx, py + d + 64, 'ÜST GÖRÜNÜŞ');

    /* ANTET */
    var F = tall ? 1.3 : 1, bw = tall ? W - 48 : 320, bh = 140 * F, bx = W - bw - 24, by;
    var below = tall || (fx + l + 90 + bw > W - 24);
    if (below) { by = py + d + 110; Hh = by + bh + 24; } else { Hh = Math.max(620, py + d + 90); by = Hh - bh - 24; }
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + Hh);
    var half = bx + bw / 2, r1 = by + 40 * F, r2 = by + 86 * F;
    rect(bx, by, bw, bh, 1);
    line(bx, r1, bx + bw, r1, .6); line(bx, r2, bx + bw, r2, .6); line(half, r2, half, by + bh, .6);
    T.appendChild(el('text', { x: bx + 16, y: by + 26 * F, 'font-size': 16 * F, 'letter-spacing': '4.5' })).innerHTML = '<tspan font-weight="600">WOODY</tspan><tspan font-weight="300">WORKZ</tspan>';
    text(bx + 16, by + 61 * F, o.title, { 'font-family': 'Cormorant, Georgia, serif', 'font-size': 21 * F });
    text(bx + 16, by + 78 * F, fmt(L) + ' × ' + fmt(D) + (hasH ? ' × ' + fmt(H) : '') + ' cm', { 'font-size': 13 * F, fill: MUTE });
    [[bx + 16, 'ÖLÇÜ BİRİMİ', 'Santimetre'], [half + 16, 'MALZEME', 'Masif meşe']].forEach(function (c) {
      text(c[0], by + 104 * F, c[1], { 'font-size': 10 * F, 'letter-spacing': '1.8', fill: MUTE });
      text(c[0], by + 123 * F, c[2], { 'font-size': 13 * F });
    });
    text(bx + bw, by - 10, 'Çizim temsilidir · tolerans ±1 cm', { 'font-size': 11.5 * F, fill: MUTE, 'text-anchor': 'end' });
  }

  function heightFor(type, n) {
    if (n.length >= 3) return n[2];
    if (/Bar Masas/i.test(type)) return 105;
    if (/Çalışma Masas/i.test(type)) return 75;
    if (/Masas/i.test(type)) return 76;
    return 0;
  }
  window.wwTeknik = function (v, d, title) {
    var n = nums(v.t), okType = /Masas|Konsol|Ünitesi|Sehpa|Bench|Kitaplık|Şaraplık/i.test(d.type || '');
    var ok = okType && n.length >= 2 && v.t.indexOf('cm') > -1;
    document.querySelectorAll('.ww-tech').forEach(function (b) { b.hidden = !ok; });
    if (!ok) return false;
    var table = /Masas/i.test(d.type || '');
    var o = { L: n[0], D: n[1], H: heightFor(d.type || '', n), t: +v.k || (table ? 4 : 3), table: table, title: title };
    document.querySelectorAll('[data-ww-tech]').forEach(function (svg) { if (svg.parentNode.clientWidth > 0) draw(svg, o); });
    return true;
  };
})();
